const revealUsp = (carBox) => {

  const trigger = carBox.querySelector('.thumbnail-car__button'),
    element = carBox.querySelector('.thumbnail-car__usp'),
    parent = element?.parentElement,
    blockHeight = element?.clientHeight;

  //element.style.maxHeight = `${blockHeight}px`;

  if (trigger) {
    trigger.addEventListener("mouseover", (e) => {
      e.preventDefault();
	  if (parent) {
		  parent.classList.toggle('opened');
	  }
    });
  }

}

export default revealUsp;
